import React from "react";
import { ButtonGroup, Button } from "reactstrap";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
export const renderUsersActions = (deleteAction, changePasswordAction, canChangePassword, cellInfo) => {
  const deleteTarget = cellInfo.original && cellInfo.original.id ? cellInfo.original : cellInfo.index;
  return (
    <ButtonGroup className="users-action-group">
      {canChangePassword ? (
        <Button
          color="warning"
          title="Change password"
          onClick={() => changePasswordAction(cellInfo.original)}
        >
          <i className="fa fa-key" />
        </Button>
      ) : null}
      <Button
        color="danger"
        title="Delete user"
        onClick={() => {
          deleteAction(deleteTarget);
        }}
      >
        <i className="fa  fa-trash" />
        {cellInfo.original.isDeleting ? (
          <>
            &nbsp;
            <Spinner size={10} animating={true} color={"white"} />
          </>
        ) : null}
      </Button>
    </ButtonGroup>
  );
};
export const renderNewUsersModalActions = (deleteAction, cellInfo) => {
  return (
    <ButtonGroup className="users-action-group">
      <Button
        color="danger"
        title="Delete draft user"
        onClick={() => {
          deleteAction([{ prop: "newUsers." + cellInfo.index }]);
        }}
      >
        <i className="fa  fa-trash" />
        {cellInfo.original.isDeleting ? (
          <>
            &nbsp;
            <Spinner size={10} animating={true} color={"white"} />
          </>
        ) : null}
      </Button>
    </ButtonGroup>
  );
};
